<template lang="pug">
.form-group.form-row.phone
  label.col-sm-4.col-form-label.form-label(for='user-phones')
    | {{ $t('user.phone_number') }}
    |  ({{ $t('user.half') }})
    span  *
  .col-sm-5
    input#user-department.form-control(
      :class="{ 'red-bordered': (!isEmpty(errors.number) && isEmpty(phone.number)) }"
      name='number'
      v-model='phone.number'
      @change='onChange'
      required=''
    )
    .invalid-feedback(
      v-if="isEmpty(phone.number)"
      v-for='obj in errors.number'
      role='alert'
    ) {{ getError(obj) }}
  div(:class="{ 'col-sm-3': (index == 0), 'col-sm-2': (index != 0) }")
    input#user-department.form-control(
      :class="{ 'red-bordered': (!isEmpty(errors.extension) && isEmpty(phone.extension)) }"
      :placeholder="`${$t('user.extension')}(${$t('user.half')})`"
      name='extension'
      v-model='phone.extension'
      @change='onChange'
    )
    .invalid-feedback(
      v-if="isEmpty(phone.extension)"
      v-for='obj in errors.extension'
      role='alert'
    ) {{ getError(obj) }}
  .col-sm-1(v-if='index != 0')
    button.mt-1.ml-2.delete-phone(@click.prevent="deletePhone")
      i.far.fa-trash-alt.icon-action
</template>

<script>
import { isEmpty } from 'lodash'
import errorMessageMixin from '@/mixins/error-message'

export default {
  mixins: [errorMessageMixin],

  props: {
    phone: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number,
      default() {
        return 0
      }
    },
    externalErrors: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      internalErrors: []
    }
  },

  computed: {
    errors() {
      return this.externalErrors
    },

    phoneObject() {
      return { ...this.phone, index: this.index }
    }
  },

  methods: {
    isEmpty,

    onChange() {
      this.$emit('change', this.phoneObject)
    },

    deletePhone() {
      this.$emit('deletePhone', this.phoneObject)
    }
  }
}
</script>
<style lang="scss" scoped>
.phone {
  .form-label {
    color: #7c91a7;
    font-size: 13px;
    font-weight: 700;
  }

  .invalid-feedback {
    color: #dc3545;
    display: block;
    font-size: 65%;
    margin-top: 0.25rem;
    width: 100%;
  }

  .delete-phone {
    background: transparent;
    border: none;
  }

  #user-department::placeholder {
    opacity: 0.4;
  }
}
</style>


